module.exports = __webpack_public_path__ + "static/media/Madhu.3db69e9b.jpeg";